<template>
    <div>
        <div class="col-sm-12">
            <div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px"
                        >{{ $t('landingPage.settingShare.titleBlock') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="shareForm.title_block"
                            :config.sync="configForm.configFieldTitleBlockShare"
                            @blur="handleValidateField(configForm.configFieldTitleBlockShare)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingShare.background') }}</label>
                    <div class="col-sm-10">
                        <UploadImageCommon
                            :fileValues.sync="shareForm.background_image"
                            :id="`BackgroundImgShare`"
                            :config="{
                                maxSize: 2048
                            }"
                        >
                            <template #warning>
                                <div style="font-size: 13px">
                                    {{ $t('noteUploadMaxMB') }}
                                </div>
                            </template>
                        </UploadImageCommon>
                        <div class="form-group row mt-2">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                            <div class="col-sm-5">
                                <div class="d-flex" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="shareForm.background_color"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="shareForm.background_color"
                                        :config="{
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </div>

                        <div>
                            <InputCheckBox
                                :model.sync="shareForm.is_repeat"
                                :id="`check-repeat-background-share`"
                                :value="shareForm.is_repeat"
                                :label="`repeat`"
                            />
                        </div>
                    </div>
                </div>
                <!-- <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingShare.url') }} </label>
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="shareForm.url"
                            :config.sync="configForm.configFieldUrlShare"
                            :disabled="true"
                            @blur="handleValidateField(configForm.configFieldUrlShare)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingShare.shareText') }}</label>
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="shareForm.share_text"
                            :config.sync="configForm.configFieldShareText"
                            @blur="handleValidateField(configForm.configFieldShareText)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingShare.hashtag') }} </label>
                    <div class="col-sm-10">
                        <KeyWordTag2
                            :id="`hashtag`"
                            checkPre="hash"
                            :model.sync="shareForm.hashtag"
                            :config.sync="configForm.configFieldHashtag"
                            @blur="handleValidateField(configForm.configFieldHashtag)"
                        >
                            <span v-if="configForm.configFieldHashtag.error">
                                {{ configForm.configFieldHashtag.errorCustomMess }}
                            </span>
                        </KeyWordTag2>
                    </div>
                </div> -->
                <div v-for="social in SOCIAL_MEDIA_SHARE" :key="social.id" class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ social.name }}</label>
                    <div class="col-sm-10">
                        <div class="form-group row">
                            <div>
                                <InputCheckBox
                                    :model.sync="shareForm.platform[social.key].active"
                                    :id="`check-social-${social.id}`"
                                    :value="shareForm.platform[social.key].active"
                                    :label="``"
                                    @change="handleChangeStatusShare(shareForm.platform[social.key])"
                                />
                            </div>
                            <div class="col-sm-11">
                                <InputText
                                    :disabled="!shareForm.platform[social.key].active"
                                    :model.sync="shareForm.platform[social.key].url"
                                    :config.sync="configForm.platform[social.key].configFieldPlatformUrl"
                                    @blur="handleValidateField(configForm.platform[social.key].configFieldPlatformUrl)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { InputText, InputCheckBox } from '@/components/Input';
import { handleDownFile } from '@/utils/format';
import { validateField } from '@/utils/validate';
import { SOCIAL_MEDIA_SHARE } from '../../constants';

import UploadImageCommon from '@/components/Uploads/Image/main.vue';
// import KeyWordTag2 from '@/components/KeywordTag/main2.vue';
import { cloneDeep } from 'lodash';

export default {
    name: 'SettingShare',
    components: {
        InputText,
        InputCheckBox,
        UploadImageCommon
        // KeyWordTag2
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        },
        configForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },

    data() {
        return {
            isVisibleEditor: false,
            SOCIAL_MEDIA_SHARE: SOCIAL_MEDIA_SHARE,
            shareForm: cloneDeep(this.dataForm)
        };
    },
    methods: {
        ...handleDownFile,

        handleValidateField(configField) {
            validateField(configField);
        },

        handleChangeStatusShare(objPlat) {
            if (!objPlat.active) {
                objPlat.url = '';
            }
            SOCIAL_MEDIA_SHARE.forEach((itemSocial) => {
                itemSocial.active = objPlat.active ?? false;
            });
        }
    },

    watch: {
        dataForm: {
            handler: function (newDataForm) {
                this.shareForm = newDataForm;
            },
            immediate: true
        },

        shareForm: {
            handler: function (newShareForm) {
                this.$emit('update:dataForm', newShareForm);
            },
            deep: true
        }
    },
    mounted() {
        setTimeout(() => {
            this.isVisibleEditor = true;
        }, 300);
    }
};
</script>

<style lang="scss" scoped></style>
